import { createAsyncThunk } from "@reduxjs/toolkit";
import toastHelper from "../../Util/toastHelper";
import API from "../../API/API";
import axios from "axios";

export const getBookings = createAsyncThunk(
  "bookings/getBookings",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.members.bookings.url,
        method: API.members.bookings.method,
      });

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const clearDoorOpen = createAsyncThunk(
  "bookings/clearDoorOpen",
  async (_, { rejectWithValue }) => {
    return null;
  },
);

export const clearGuestDoorOpen = createAsyncThunk(
  "bookings/clearGuestDoorOpen",
  async (_, { rejectWithValue }) => {
    return null;
  },
);

export const openDoor = createAsyncThunk(
  "bookings/openDoor",
  async (params: { amenityId: string }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios({
        url: API.members.openDoor.url,
        method: API.members.openDoor.method,
        data: params,
      });

      toastHelper.success(data?.message);
      setTimeout(() => {
        dispatch(clearDoorOpen());
      }, 3000);

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const openGuestDoor = createAsyncThunk(
  "bookings/openGuestDoor",
  async (
    params: {
      amenityId: string;
      guestUuid: string;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data } = await axios({
        url: API.members.openGuestDoor.url,
        method: API.members.openGuestDoor.method,
        data: params,
      });

      toastHelper.success(data?.message);
      setTimeout(() => {
        dispatch(clearGuestDoorOpen());
      }, 3000);

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getAmenitiesList = createAsyncThunk(
  "bookings/getAmenitiesList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.members.amenitiesList.url,
        method: API.members.amenitiesList.method,
      });
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const createBooking = createAsyncThunk(
  "bookings/createBooking",
  async (
    params: {
      content: string;
      amenityId: string;
      startTime: string;
      endTime: string;
      total: string;
      signature: string;
      MemberCCInfoId: string | null;
      description: string;
      noOfGuest: string;
      uuid: string;
      voucherCode: string;
      cleanupHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.members.createBooking.url,
        method: API.members.createBooking.method,
        data: params,
      });
      params.cleanupHandler();
      toastHelper.success("Booking created successfully");
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const extendBooking = createAsyncThunk(
  "bookings/extendBooking",
  async (
    params: {
      bookingId: string;
      endTime: string;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.members.extendBooking.url,
        method: API.members.extendBooking.method,
        data: params,
      });
      params.successHandler();
      toastHelper.success(data?.message);
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const addBookingGuest = createAsyncThunk(
  "bookings/addBookingGuest",
  async (
    params: {
      bookingUUid: string;
      firstName: string;
      lastName: string;
      email: string;
      phoneNumber: string;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.members.addBookingGuest.url,
        method: API.members.addBookingGuest.method,
        data: params,
      });
      params.successHandler();
      toastHelper.success(data?.message);
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getBookingByGuestUuid = createAsyncThunk(
  "bookings/getBookingByGuestUuid",
  async (params: { bookingUuid: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.members.getBookingByGuestUuid.url + params.bookingUuid,
        method: API.members.getBookingByGuestUuid.method,
      });
      return data?.booking;
    } catch (error: any) {
      // if (error?.response?.data?.message) {
      //   toastHelper.error(error?.response?.data?.message);
      // } else {
      //   toastHelper.error("Something went wrong");
      // }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getGuestAmenityAccess = createAsyncThunk(
  "bookings/getGuestAmenityAccess",
  async (params: { guestUuid: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.members.guestAmenityAccess.url + params.guestUuid,
        method: API.members.guestAmenityAccess.method,
      });
      return data;
    } catch (error: any) {
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const cancelBookingUser = createAsyncThunk(
  "bookings/cancelBookingUser",
  async (
    params: { bookingId: number; successHandler: () => void },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.members.cancelBooking.url + params.bookingId,
        method: API.members.cancelBooking.method,
      });
      toastHelper.success(data?.message);
      params.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);
